import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultFormControlFocusHoverContext = {
  focused: false,
  hovered: false
};
export const FormControlFocusHoverContext = /*#__PURE__*/createContext(defaultFormControlFocusHoverContext);
const {
  Consumer,
  Provider
} = FormControlFocusHoverContext;
export { Consumer as FormControlFocusHoverContextConsumer };
export const FormControlFocusHoverContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Provider, {
    value: props,
    children: children
  });
};